export enum DateFormat {
    'DEFAULT' = 'dd/MM/yyyy',
    'FULL' = 'dd/MM/yyyy à HH\'h\'mm',
    'ISO' = 'ISO',
}
